import { Search } from 'lucide-react';
import React from 'react';

export default function SearchForm({ variant }) {
  return (
    <form className={`docpro_search_form ${variant ? variant : ''}`}>
      <button className="docpro_search_btn">
        <Search width={20} height={20} />
      </button>
      <input type="text" placeholder="Search" className="docpro_search_input" />
      <div className="docpro_dropdown">
        <div className="docpro_dropdown_item">Search Suggession Item 1</div>
        <div className="docpro_dropdown_item">Search Suggession Item 2</div>
        <div className="docpro_dropdown_item">Search Suggession Item 3</div>
      </div>
    </form>
  );
}
